import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { SubjectPropertyInformationLeadStore } from './subject-property-information-lead.store';

@Injectable({ providedIn: 'root' })
export class SubjectPropertyInformationLeadQuery extends Query<Models.SubjectPropertyInformationLeadForm> {
  protected store: SubjectPropertyInformationLeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(SubjectPropertyInformationLeadStore);

    super(store);

    this.store = store;
  }
}
